import GetRedebitByIdRequestModelBase from '../_generated/modelBases/get-redebit-by-id-request-model-base';

export default class GetRedebitByIdRequestModel extends GetRedebitByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
